import React from 'react';
import './styles.scss';
import { InputSize } from '../models/InputSize';
import _uniqueId from 'lodash/uniqueId';
import { Label } from '../Label';
import { InputPropsBase } from '../interfaces/Inputs';
import { InputContainer } from '../InputContainer';
import { JustifyContents } from '../../layout';

interface InputRadioProps extends InputPropsBase<boolean, boolean> {}

export function InputRadio(props: InputRadioProps): JSX.Element {
    const id = _uniqueId('id-');
    const onBlur = () => {
        props.onBlur && props.onBlur(props.value);
    };
    return (
        <InputContainer
            gap={props.gap || 15}
            justify={props.justify || JustifyContents.flexStart}
            align={props.align}
            overflow={props.overflow}
            height={props.height || '100%'}
            width={props.width || '100%'}
        >
            <Label
                id={props.id || id}
                content={props.label}
                disabled={props.disabled === true}
                labelPosition={props.labelPosition}
                labelLength={props.labelLength || 0}
                className={props.labelClassName}
            >
                <div
                    className={
                        'radio-element' +
                        (props.size === InputSize.Small ? ' small-radio' : '') +
                        (props.size === InputSize.Medium ? ' medium-radio' : '') +
                        (props.size === InputSize.Large ? ' large-radio' : '') +
                        (props.className ? ' ' + props.className : '')
                    }
                    style={{ flex: props.inputLength || 0 }}
                >
                    <label htmlFor={props.id || id} className={'radio-element radio'}>
                        <input
                            type="radio"
                            id={props.id || id}
                            name={props.name}
                            disabled={props.disabled === 'inputOnly' || props.disabled === true}
                            checked={props.value}
                            className="radio-element radio__input"
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                                props.onChange && props.onChange(e.target.checked)
                            }
                            onBlur={onBlur}
                            tabIndex={props.disabled === 'inputOnly' || props.disabled === true ? -1 : 0}
                        />
                        <div
                            className={
                                'radio-element radio__radio' +
                                (props.disabled === 'inputOnly' || props.disabled === true ? ' disabled' : '')
                            }
                            tabIndex={props.disabled === 'inputOnly' || props.disabled === true ? -1 : 0}
                            onFocus={() => props.onChange && props.onChange(true)}
                        >
                            <div
                                className={
                                    props.value
                                        ? `radio__radio__inner ${
                                              props.disabled === 'inputOnly' || (props.disabled === true && 'disabled')
                                          }`
                                        : ''
                                }
                            />
                        </div>
                    </label>
                </div>
            </Label>
        </InputContainer>
    );
}
